
import { defineComponent, Ref, ref, ComputedRef, computed, onMounted, reactive, toRaw } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import {
    PaginationConfig,
    logisticsResTableDataType,
    OrderInfoParams,
    LabelResType,
    OrderInfoSearch,
    updateOrderType,
    TableListQueryParams,
    getEventCodeListType
} from './data.d'

import type {TableProps,TableColumnType} from 'ant-design-vue'

import {StateType as LogisticsStateType} from './store'
import {StateType as LoadingStateType} from '@/store/loding'
import {StateType as UploadStateType} from '@/store/upload'
import {StateType as CountryStateType} from '@/store/country'
import {StateType as UserStatusStateType} from '@/store/userstatus'

import { message, Form } from 'ant-design-vue'
import {LoadingOutlined} from '@ant-design/icons-vue'

import downloadfile from '@/utils/download'

import LogistDetail from './component/logistdetail/index.vue'
import NoodlePrint from './component/noodleprint/index.vue'
import RemarksData from './component/remarks/index.vue'
import BaseMsg from './component/basemsg/index.vue'
import BatchImport from './component/batchimport/index.vue'
import CancelOrder  from './component/cancelorder/index.vue'

import { validateInfos } from 'ant-design-vue/lib/form/useForm'
const useForm = Form.useForm;
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
import dayjs from 'dayjs'

import {UploadRes, UserInfoParams} from '@/services/data.d'

interface paginationDir {
    pageNo: number;
    pageSize: number;
}

interface ImageParams {
    id: string;
}

interface LogisticsQuerySetupData {
    columns: any;
    activeKey: any;
    rowSelection: any;
    pagination: ComputedRef<PaginationConfig>;
    loading: Ref<boolean>;
    loadingBtn: Ref<boolean>;
    visible: Ref<boolean>;
    isRemarks: Ref<boolean>;
    typeStr: Ref<string>;
    list: ComputedRef<any[]>;
    tableData: any;
    title: ComputedRef<any>;
    labelData: ComputedRef<LabelResType>;
    modelRef: OrderInfoSearch;
    validateInfos: ComputedRef<validateInfos>;
    defaultRemarks: any;
    imgUrl: ComputedRef<UploadRes>;
    countrylist: ComputedRef<any[]>;
    logisticsData: any;
    isNum: Ref<any>;
    queryList: Ref<any>;
    orderList: any;
    countrylistSet: Ref<any>;
    eventCodeList: Ref<any>;
    filterOption: (input:string,option:any) => any;
    handleDownload: (e: MouseEvent) => void;
    handleShow: (record: any, type: string) => void;
    handleSearch: (e: MouseEvent) => void;
    handleAddRemarks: (e: MouseEvent, type:string) => void;
    getChildRemarks:(childRemarksInfo:updateOrderType) => void;
    handleTableChange: (pagination: PaginationConfig) => void;
    handleOrderCtrl: (record: any, type:string) => void;
    createdLogistics: (e: MouseEvent) => void;
    changeTxt:(val:string, type?: string) => string;
    handleRest: (e: MouseEvent) => void;
    handleGotoCheck: (type: string) => void;
    statusCommit: (type: string) => void;
}

export default defineComponent({
    name: 'LogisticsQuery',
    components: {
        LoadingOutlined,
        LogistDetail,
        NoodlePrint,
        RemarksData,
        BaseMsg,
        BatchImport,
        CancelOrder
    },
    setup(): LogisticsQuerySetupData {
        const router = useRouter()
        const store = useStore<{
            logisticsquery: LogisticsStateType,
            loading: LoadingStateType,
            upload: UploadStateType,
            country: CountryStateType,
            userstatus: UserStatusStateType
        }>()
        const activeKey = ref('1')
        const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
        const loading = ref<boolean>(false)
        const loadingBtn = ref<boolean>(false)
        const visible = ref<boolean>(false)
        const isRemarks = ref<boolean>(false)
        const orderList = reactive<any>({})
        const tableData = reactive<any>({})
        const logisticsData = reactive<any>({})
        const defaultRemarks = reactive<any>({})
        const typeStr = ref<string>('')
        const pageNum = reactive<paginationDir>({pageNo:1,pageSize:20})
        const searchFormData = reactive<any>({})
        const isNum = ref<any>()
        const queryList = reactive<any>({})
        const imgUrl = ref<any>({});
        const countrylistSet = ref<any>([])
        const columns: TableColumnType<logisticsResTableDataType>[] = [
            // {title:'物流单来源', dataIndex:'orderSource', width: 100},
            {title:'目的国', dataIndex:'destination', width: 100},
            {title:'产品类别', dataIndex:'productType', width: 100},
            // {title:'商品属性', dataIndex:'hasBattery', width: 100},
            {title:'交易订单号', dataIndex:'transactionNo',ellipsis: false, width: 220},
            {title:'CLUAN单号', dataIndex:'gwtNo', ellipsis: false, width: 160},
            {title:'订单创建日期', dataIndex:'createdAt',  width: 160},
            // {title:'目的国派送服务商', dataIndex:'lmService',ellipsis: true, width: 150},
            {title:'目的国派送单号', dataIndex:'deliveryNo',ellipsis: false, width: 220},
            {title:'订单节点状态', dataIndex:'eventCodeCn', ellipsis: true, width: 160},
            // {title:'揽收日期', dataIndex:'ascanTime', ellipsis: true, width: 160},
            // {title:'完成日期', dataIndex:'lastsyncTime', ellipsis: true, width: 160},
            {title:'操作', dataIndex:'action', fixed:'right', width: 170},
        ]

        const rowSelection: TableProps['rowSelection'] = {
            onChange: (selectedRowKeys: any[],selectedRows:logisticsResTableDataType[]) => {
                queryList.value = selectedRows
                console.log(queryList.value)
            },
            // getCheckboxProps:(record) => ({
            //     props:{
            //         disabled: record.noodlesPrint
            //     }
            // })
        }

        const list = computed<logisticsResTableDataType[]>(() => store.state.logisticsquery.tableData.orderlist)
        const pagination = computed<PaginationConfig>(() => store.state.logisticsquery.tableData.pagination)
        const labelData = computed<LabelResType>(()=>store.state.logisticsquery.labelInfo)

        //弹框标题
        const title = computed<any>(()=>{
            const tit = {
                gwt: '信息查看',
                label: '面单打印',
                batchPrinting: '面单打印',
                remarks: '添加备注',
                eventCodeCn: '物流轨迹',
                batchimport: '批量上传物流单',
                batchCancel: '批量取消物流单',
                msg: '信息提示'
            }
            return tit[typeStr.value] || ''
        })

        //查询
        const modelRef = reactive<OrderInfoSearch>({
            gwtNo: '',
            deliveryNo: '',
            modelRef: '',
            eventCodeDisplay: '',
            transactionNo: '',
            orderSource: '',
            isPrint: '',
            destination: '',
            transportDay: '',
            pickupStatus: '',
            status: '',
            sttime: [],
            entime: [],
        })
        const rulesRef = reactive({
            gwtNo: [],
            deliveryNo: [],
            modelRef:[],
            eventCodeDisplay:[],
            transactionNo: [],
            orderSource: [],
            isPrint: [],
            destination: [],
            transportDay: [],
            pickupStatus: [],
            status: [],
            sttime: [],
            entime: [],
        })
        const { resetFields, validate, validateInfos } = useForm(modelRef, rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSearch = async(e: MouseEvent) => {
            e.preventDefault()
            const fieldsValue = await validate<OrderInfoSearch>()
            const data = returnParams(fieldsValue)
            pageNum.pageNo = 1
            const params = {...pageNum,...data}
            searchFormData.value = data
            data.gwtNo==''?queryList.value = []:null
            getOrlderList(params)
        }

        //参数返回
        const returnParams = (fieldsValue: any) => {
            let gest = fieldsValue.sttime&&fieldsValue.sttime[0]|| ''
            let geet = fieldsValue.sttime&&fieldsValue.sttime[1]|| ''
            let exst = fieldsValue.entime&&fieldsValue.entime[0]|| ''
            let exet = fieldsValue.entime&&fieldsValue.entime[1]|| ''
            let startOrderDate = gest==''?'':dayjs(gest).format('YYYY-MM-DD 00:00:00')
            let endOrderDate = geet==''?'':dayjs(geet).format('YYYY-MM-DD 23:59:59')
            let startJyDate = exst==''?'':dayjs(exst).format('YYYY-MM-DD 00:00:00')
            let endJyDate = exet==''?'':dayjs(exet).format('YYYY-MM-DD 23:59:59')
            return {
                gwtNo: fieldsValue.gwtNo,
                deliveryNo: fieldsValue.deliveryNo,
                transactionNo: fieldsValue.transactionNo,
                orderSource: fieldsValue.orderSource,
                isPrint: Boolean(fieldsValue.isPrint),
                destination: fieldsValue.destination,
                transportDay: fieldsValue.transportDay,
                pickupStatus: fieldsValue.pickupStatus,
                status: fieldsValue.status,
                eventCodeDisplay: fieldsValue.eventCodeDisplay,
                startOrderDate,
                endOrderDate,
                startJyDate,
                endJyDate,
                userCode: userMsg.userCode,
                userName: userMsg.userName
            }
        }

        //分页
        const handleTableChange = (pagination:PaginationConfig) => {
            pageNum.pageNo = pagination.current
            pageNum.pageSize = pagination.pageSize
            const params = searchFormData.value ? {...searchFormData.value,...pageNum} : {userCode: userMsg.userCode, ...pageNum}
            getOrlderList(params)
        }

        //获取列表
        const getOrlderList = async(params:TableListQueryParams)=> {
            loading.value = true
            try {
                await store.dispatch('logisticsquery/getOrderAddressPageListFn',params)
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
          // console.log(999, pagination.value.total)
          // console.log(999, pagination.value.pageSize)
        }

        //订单详情
        const getOrderInfo = async(params: OrderInfoParams) => {
            loading.value = true
            try {
                let res: boolean = await store.dispatch('logisticsquery/getorderInfoFn',params)
                if(res===true){
                    tableData.baseList = []
                    tableData.addresseeAddess = []
                    tableData.senderAddess = []
                    tableData.orderSkuList = []
                    tableData.userAddress = []
                    tableData.orderEventList = []
                    const resData = store.state.logisticsquery.orderInfo
                    let t0={},t1={},t2={}, t3={}
                    Object.keys(resData).forEach((item:string)=>{
                        if(item!='addresseeAddess'&&item != 'senderAddess'&&item != 'orderSkuList' &&item != 'userAddress'&&item != 'orderEventList'){
                            t0[item]=resData[item]
                        }
                    })
                    resData.addresseeAddess&&Object.keys(resData.addresseeAddess).forEach((item:string)=>{t1[item]=resData.addresseeAddess[item]})
                    resData.senderAddess&&Object.keys(resData.senderAddess).forEach((item:string)=>{t2[item]=resData.senderAddess[item]})
                    resData.userAddress&&Object.keys(resData.userAddress).forEach((item:string)=>{t3[item]=resData.userAddress[item]})
                    tableData.baseList.push(t0)
                    tableData.addresseeAddess.push(t1)
                    tableData.senderAddess.push(t2)
                    tableData.userAddress.push(t3)
                    tableData.orderSkuList = resData.orderSkuList
                    tableData.orderEventList = resData.orderEventList.filter(item => item.display == true)
                    visible.value = true
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        //面单打印
        const imgId = computed<LabelResType>(()=>store.state.logisticsquery.labelInfo)
        const labelinfo = async(params:any) => {
            loading.value = true
            try {
                const res: boolean = await store.dispatch('logisticsquery/getorderLabelFn',params)
                if(res===true){
                    getImageInfo({id: String(imgId.value.imgFileId)})
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        //获取图片
        // const imgUrl = computed<UploadRes>(()=> store.state.upload.imageUrlRes)
        const getImageInfo = async(params:ImageParams) => {
            try {
                const res: boolean = await store.dispatch('upload/getImgUrlFn', params)
                if(res===true){
                    imgUrl.value = store.state.upload.imageUrlRes
                    visible.value = true
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

      const handleDownLabelsOk = async (params:any) => {
        loadingBtn.value = true;
        // 调用batchCancelOrder接口
        try {
          let downloadUrl: string = await store.dispatch('logisticsquery/downLabelsFn',params)
          if((!downloadUrl || downloadUrl !='') && downloadUrl.indexOf("http") != -1){
            const a = document.createElement('a')
            a.href = downloadUrl
            a.target = '_blank'
            a.setAttribute('download', '面单_' + Date.now() + '.pdf')
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            window.URL.revokeObjectURL(downloadUrl)
          }else{
            message.warning(downloadUrl || '未查到相关记录')
          }
        } catch (error) {
          message.warning('error')
          // eslint-disable-next-line no-empty
        } finally {
          loadingBtn.value=false;
        }

      }

        //显示弹框
        const handleShow = (record: any, type: string) => {
            typeStr.value = type
            if(type == 'gwt'){
                getOrderInfo({gwtNo: record.gwtNo})
            }
            if(type == 'label'){
              // record.firstImgFileId ? labelinfo({gwtNo: record.gwtNo}) : message.warning('当前订单的状态未查到面单信息，无法打印！')
              // labelinfo({gwtNo: record.gwtNo})
              handleDownLabelsOk([record.gwtNo])
            }
            if(type == 'eventCodeCn'){
                seeLogistics({gwosOrderNo:record.gwtNo,display: true})
            }
            if(type == 'batchimport'){
                visible.value = true
            }
            if(type == 'batchPrinting' || type == 'batchCancel'){
                if(queryList.value && queryList.value.length > 0){
                    const params = queryList.value.map((item:any) => {
                        return item.gwtNo
                    })
                  // type == 'batchPrinting' ? batchPrintingFn(params) : orderBatchCancelFn(params)
                  type == 'batchPrinting' ? handleDownLabelsOk(params) : orderBatchCancelFn(params)
                }else{
                    type == 'batchPrinting' ? message.error('请选择需要批量打印的物流单') : message.error('请选择需要批量取消的物流单')
                }
            }
        }

        // 批量取消订单
        const orderBatchCancelFn = async(params:any) => {
            orderList.value = params
            typeStr.value = 'batchCancel';
            visible.value = true;
            // loading.value = true
            // try {
            //     let res: boolean = await store.dispatch('logisticsquery/orderBatchCancelFn',params)
            //     if(res===true){
            //         message.success('取消成功')
            //         getOrlderList(pageNum)
            //     }
            // } catch (error) {
            //     message.warning('error=>'+error)
            // }
            // loading.value = false
        }

        // 批量打印订单
        const batchPrintingFn = async(params:any) => {
            loading.value = true
            try {
                let res: boolean = await store.dispatch('logisticsquery/orderBatchLabelFn',params)
                if(res===true){
                    const url = store.state.logisticsquery.batchLabelDataList.labelBase64
                    if(url == ''){
                        message.warning('当前订单的状态未查到面单信息，无法打印！')
                    }else{
                        imgUrl.value = store.state.logisticsquery.batchLabelDataList
                        visible.value = true
                    }
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        // 查看物流轨迹
        const seeLogistics = async(params:any) => {
            loading.value = true
            try {
                let res: boolean = await store.dispatch('logisticsquery/seeLogisticeFn',params)
                if(res===true){
                    visible.value = true
                    logisticsData.value = store.state.logisticsquery.seeLogistice.list;
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        // 添加备注
        const handleAddRemarks = (record:any,type:string) => {
            typeStr.value = type
            defaultRemarks.gwtNo = record.gwtNo
            defaultRemarks.remarks = record.remarks
            visible.value = true
        }
        //子组件返回数据
        const getChildRemarks = (childRemarksInfo:updateOrderType) => {
            addRemarks(childRemarksInfo)
        }
        //添加备注api
        const addRemarks = async(params: updateOrderType) => {
            loading.value = true
            try {
                let res: boolean = await store.dispatch('logisticsquery/updateOrderFn',params)
                if(res===true){
                    visible.value = false
                    getOrlderList(pageNum)
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        //导出
        const handleDownload = async(e: MouseEvent) => {
            e.preventDefault()
            const fieldsValue = await validate<OrderInfoSearch>()
            const data = returnParams(fieldsValue)
            let gwtno:string[] = []
            queryList.value&&queryList.value.map((item:any) => gwtno.push(item.gwtNo))
            const gtno = gwtno.join(',')
            const params = {...data, gwtNo: data.gwtNo==''&&gtno==''?'':`${data.gwtNo} ${gtno}`.trim()}
            try {
                downloadfile({
                    params,
                    url: '/seller/v1/order/exportOrder',
                    meth: 'post',
                    type: 'text/plain',
                    filename: `物流单_${new Date().getTime()}.xlsx`,
                })
            } catch (error) {
                message.warning('error')
            }
        }
        //创建物流单
        const createdLogistics = (e: MouseEvent) => {
            e.preventDefault()
            const {userCode} = userMsg
            getuserstatus({userCode})
        }

        //取消订单
        const handleOrderCtrl = (record: any, type: string) => {
            const params = {
                gwtNo: record.gwtNo,
                reason: type
            }
            orderctrl(params)
        }

        //取消订单接口
        const orderctrl = async(params:any) => {
            loading.value = true
            try {
                const res:boolean = await store.dispatch('logisticsquery/orderCancelFn',params)
                if(res===true){
                    message.success('订单取消中，等待取消结果')
                }
            } catch (error) {
                message.warning('error=>'+error)
            }
            loading.value = false
        }

        //国家
        const countrylist = computed<any[]>(()=>store.state.country.countryCn)
        const getCountryFn = async()=>{
            try {
                await store.dispatch('country/getCountryFn')
            } catch (error) {
                message.warning('error=>'+error)
            }
        }

        //模糊搜索国家
        const filterOption = (input: string, option: any) => {
            return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }

        //枚举转换
        const changeTxt = (val:string, type?:string) => {
            const tObjS = {1: '订单待揽收',2: '揽收单处理中',3: '揽收单处理成功',4: '取消中-待确认',5: '已取消',6: '取消失败',7: '下单失败'}
            const tObjO = {1: 'cluan',2: '通途',3: '其它'}
            const proTypeObj={1:'标准'}
            switch(type){
                case 'status':
                    return tObjS[val] || val
                case 'eventCodeCn':
                  return val || '下单失败'
                case 'orderSource':
                    return tObjO[val] || '无来源'
                case 'ascanTime':
                    if(val&&val.includes('1000-01-01T00:00:00')){
                        return '00-00-00 00:00:00'
                    }else{
                        return val&&val.replace('T',' ') || val
                    }
                case 'productType':
                    return proTypeObj[val] || '-'
                default:
                    return val
            }

        }

        //重置
        const handleRest = (e: MouseEvent) => {
            e.preventDefault()
            resetFields()
            let params = {userCode:userMsg.userCode,...pageNum}
            getOrlderList(params)
            getCountryFn()
        }

        //检查用户状态
        const getuserstatus = async(params:UserInfoParams) => {
            try {
                const res: boolean = await store.dispatch('userstatus/checkUserStatusFn', params)
                if(res === true){
                    const info:any = store.state.userstatus.info
                    console.log('info', info);
                    if(info.body){
                        router.push({
                            path:'/logistics/addlogistics'
                        })
                    }else{
                        visible.value = true
                        typeStr.value = 'msg'
                        isNum.value = info.msg
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }

        //跳转至验证页面
        const handleGotoCheck = (type: string) => {
            visible.value = false
            if(type=='check'){
                router.replace('/personal/account')
            }else{
                router.replace('/account/recharge')
            }
        }

        const statusCommit = (type:string) => {
            console.log(type)
            if(type == 'statusCommit'){
                let params = {userCode:userMsg.userCode,...pageNum}
                getOrlderList(params)
            }
        }

        //查询Gwos_Event_Code列表
        const eventCodeList = computed<any[]>(()=> store.state.logisticsquery.gwosEventCodeData)
        const gwosEventCode = async(params:getEventCodeListType) => {
            try {
                const res: boolean = await store.dispatch('logisticsquery/gwosEventCodeFn', params)
                if(res === true){
                    // console.log('查询Gwos_Event_Code列表',store.state.logisticsquery.gwosEventCodeData)
                }
            } catch (error) {
                console.log(error);
            }
        }

        const init = ()=>{
            countrylistSet.value = JSON.parse(String(localStorage.getItem('person')))
            let params = {userCode:userMsg.userCode,...pageNum}
            getOrlderList(params)
            getCountryFn()
            gwosEventCode({isDeleted:false,isDisplay:true})
        }

        onMounted(()=>{
            init()
        })

        return {
            activeKey,
            columns,
            rowSelection,
            pagination,
          loading,
          loadingBtn,
            visible,
            title,
            typeStr,
            list,
            tableData,
            labelData,
            validateInfos:validateInfosNew,
            modelRef,
            isRemarks,
            imgUrl,
            countrylist,
            isNum,
            defaultRemarks,
            handleDownload,
            handleShow,
            handleSearch,
            handleAddRemarks,
            getChildRemarks,
            handleTableChange,
            handleOrderCtrl,
            createdLogistics,
            filterOption,
            changeTxt,
            logisticsData,
            handleRest,
            handleGotoCheck,
            queryList,
            orderList,
            countrylistSet,
            statusCommit,
            eventCodeList
        }
    }
})
